import { ArrowBackIos, ArrowForwardIos, ExpandMore } from "@mui/icons-material";
import { Accordion, AccordionDetails, AccordionSummary, IconButton } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation, useRevalidator } from "react-router-dom";

import useService from "../../../hooks/useService";

import Header from "./components/Header";
import ReportTable from "./components/ReportTable";

const KPIReport = () => {
  const metricTableRepository = useService("repositories/metric-table-repository");
  const revalidator = useRevalidator();
  const [retrievedMetrics, setRetrievedMetrics] = useState([]);
  const location = useLocation();

  useEffect(() => {
    getMetrics("-1");
  }, []);

  const getMetrics = async (week_offset) => {
    const params = new URLSearchParams(location.search);
    try {
      if (params.get("user")) {
        const metrics = await metricTableRepository.findRecord({
          user: params.get("user"),
          week_offset: week_offset,
        });
        if (metrics) {
          setRetrievedMetrics(metrics);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleWeekSwitcher = (offset) => {
    getMetrics(offset);
    revalidator.revalidate();
  };
  return (
    <>
      {retrievedMetrics?.reports && retrievedMetrics?.reports.length > 0 && (
        <div id="Report-Detail" data-testid="Report" className="mt-6 bg-white shadow-md">
          <div className="p-4">
            <h1 className={`text-left text-xl font-bold`}>KPI Reports</h1>

            <div className="w-100 h-[80px] justify-items-center">
              <div className="grid grid-flow-col">
                <IconButton
                  className="text-blue-500"
                  aria-label="delete"
                  disabled={!retrievedMetrics?.previous}
                  onClick={() => handleWeekSwitcher(retrievedMetrics?.previous)}
                >
                  <ArrowBackIos />
                </IconButton>

                <div className="w-[300px] text-center align-middle">
                  <div className="align-text-middle text-l">
                    <p className="font-bold">{"Reports for the week of:"}</p>
                    <p>{retrievedMetrics?.startDate + " - " + retrievedMetrics?.endDate}</p>
                  </div>
                </div>

                <IconButton
                  className="text-blue-500"
                  aria-label="delete"
                  disabled={!retrievedMetrics?.next}
                  onClick={() => handleWeekSwitcher(retrievedMetrics?.next)}
                >
                  <ArrowForwardIos />
                </IconButton>
              </div>
            </div>
            {retrievedMetrics?.reports && retrievedMetrics?.reports.length > 0 ? (
              retrievedMetrics?.reports.map((report, idx) => (
                <>
                  <Accordion key={"_" + idx}>
                    <AccordionSummary
                      expandIcon={<ExpandMore />}
                      aria-controls="panel1-content"
                      id="panel1-header"
                    >
                      <Header name={report.name} role={report.role} />
                    </AccordionSummary>
                    <AccordionDetails className="mx-2 border-t border-gray-300">
                      <div>
                        {report.tables.map((table, idx) => (
                          <div className="mb-10" key={idx}>
                            <ReportTable data={table} />
                          </div>
                        ))}
                      </div>
                    </AccordionDetails>
                  </Accordion>
                </>
              ))
            ) : (
              <div>Nothing to Show</div>
            )}
          </div>
        </div>
      )}{" "}
    </>
  );
};
export default KPIReport;
